<section class="container-fluid">
  <div class="form-register">
    <form [formGroup]="formInvoiceDetail">
      <div class="row mb-1">
        <div class="col-lg-2 col-md-3 col-sm-6 col-12">
          <app-custom-autocomplete formControlName="conceptInvoicingId" [labelText]="'Concepto Fra.'"
            [list]="listConceptInvoicing" [required]="true" [recovery]="true"
            (onChangeSelect)="getConceptInvoicing($event, true)">
          </app-custom-autocomplete>
        </div>
        <div class="col-lg-3 col-md-3 col-sm-6 col-12">
          <app-custom-autocomplete formControlName="articleId" [labelText]="'Artículo'" [list]="listArticles"
            [required]="true" [recovery]="true" [showExtraButton]="true" [titleExtraButton]="'Seleccionar Artículo'"
            [iconExtraButton]="'pi pi-external-link'" [disabled]="articleModaldisable"
            (clickExtraButton)="openArticleSelectionModal()" (onChangeSelect)="getArticle($event, true)">
          </app-custom-autocomplete>
          <app-custom-modal #articleSelection [label]="'Seleccionar'" [header]="'Selección de Equipos'"
            [children]="componentTableSelection" [inputs$]="inputsForArticlesSelection$" [output$]="output$"
            (selectedItems)="handleSelectedItem($event)" hidden></app-custom-modal>
        </div>
        <div class="col-lg-2 col-md-3 col-sm-6 col-12">
          <app-custom-autocomplete formControlName="storeId" [labelText]="'Bodega'" [list]="listStoreFiltered"
            [required]="true" [recovery]="true" (onChangeSelect)="getStore($event, true)">
          </app-custom-autocomplete>
        </div>
        <div class="col-lg-1 col-md-3 col-sm-4 col-6">
          <app-custom-input-decimal [value]="stock" [labelText]="'Existencia'"
            [disabled]="true"></app-custom-input-decimal>
        </div>
        <div class="col-lg-1 col-md-3 col-sm-2 col-6 affects-inventory">
          <app-custom-checkbox formControlName="affectsInventory" [labelText]="'Afecta Inv.'"
            [disabled]="enableAffectsInventory"></app-custom-checkbox>
        </div>

        <div class="col-lg-1 col-md-3 col-sm-3 col-6">
          <app-custom-input-text formControlName="document" [labelText]="'Documento'"
            [maxLength]="10"></app-custom-input-text>
        </div>
        <div class="col-lg-1 col-md-3 col-sm-3 col-6">
          <app-custom-input-text formControlName="accountingCostCenter" [labelText]="'C.Costo Cont.'" [required]="false"
            [maxLength]="10"></app-custom-input-text>
        </div>
        <div class="col-lg-1 col-md-3 col-sm-3 col-6">
          <app-custom-datepicker formControlName="dateInitial" [labelText]="'Fecha Inicial'" [required]="true"
            (onChangeDate)="changeDateIni($event)"></app-custom-datepicker>
        </div>
        <div class="col-lg-1 col-md-3 col-sm-3 col-6">
          <app-custom-datepicker formControlName="dateFinal" [labelText]="'Fecha Final'" [required]="true"
            (onChangeDate)="changeDateFin()"></app-custom-datepicker>
        </div>
        <div class="col-lg-1 col-md-3 col-sm-3 col-6">
          <app-custom-input-number formControlName="totalTime" [labelText]="'Días'" [required]="true"
            (onChangeNumber)="calculateTotalValue()"></app-custom-input-number>
        </div>
        <div class="col-lg-1 col-md-3 col-sm-3 col-6">
          <app-custom-input-decimal formControlName="quantity" [labelText]="'Cantidad'" [required]="true"
            (onChangeNumber)="changeQuantity()"></app-custom-input-decimal>
        </div>
        <div class="col-lg-1 col-md-3 col-sm-3 col-6">
          <app-custom-input-decimal formControlName="residue" [labelText]="'Saldo'" [required]="true"
            [disabled]="true"></app-custom-input-decimal>
        </div>
        <div class="col-lg-1 col-md-3 col-sm-3 col-6">
          <app-custom-input-decimal formControlName="unitValueWithDiscount" [labelText]="'Vr.Unitario'"
            [required]="true" (onChangeNumber)="calculateTotalValue()"></app-custom-input-decimal>
        </div>
        <div class="col-lg-1 col-md-3 col-sm-3 col-6">
          <app-custom-input-decimal formControlName="totalValueWithDiscount" [labelText]="'Vr.Total'" [required]="true"
            [disabled]="true"></app-custom-input-decimal>
        </div>
        <div class="col-lg-2 col-md-12 col-sm-12 col-12 d-flex align-items-end gap-2">
          <app-custom-button [title]="'Guardar'" [label]="'Guardar'" [disabled]="disableButtonSave" (onClick)="send()">
          </app-custom-button>
          <app-custom-button [title]="'Cancelar'" [label]="'Cancelar'" [severity]="'danger'" (onClick)="cancel()">
          </app-custom-button>
        </div>
      </div>
    </form>
  </div>
</section>